export function adjustOverlayPosition(overlay: HTMLElement, padding: any[]) {
  const rect = overlay.getBoundingClientRect();
  const style = getComputedStyle(overlay);
  const windowWidth = window.innerWidth;
  const [paddingTop = 0] = padding || [0];
  const [, paddingRight = paddingTop, paddingBottom = paddingTop] = padding || [0];
  const [,,, paddingLeft = paddingRight || paddingTop] = padding || [0];

  let newTop = rect.top;
  let newLeft = rect.left;

  // Check and fix the left and right sides
  if (rect.left < 0) {
    newLeft = paddingLeft;
    console.debug('out of viewport', 'left');
  } else if (rect.right > windowWidth) {
    console.debug('out of viewport', 'right');
    newLeft = windowWidth - rect.width - paddingRight;
  }

  // Check and fix the top and bottom sides
  if (rect.top < 0) {
    newTop = paddingTop;
    console.debug('out of viewport', 'top');
  } else if (style.bottom.includes('-')) {
    console.debug('out of viewport', 'bottom');
    // When it overflows at the bottom, flip it to be displayed above.
    newTop -= parseFloat(style.height) + paddingBottom;
  }

  // Apply the corrected position
  overlay.style.left = `${newLeft}px`;
  overlay.style.top = `${newTop}px`;
}